
import { Investment } from "@/types/investment";
import { formatCurrency } from "./utils";

interface CurrentInformationProps {
  investment: Investment;
}

const CurrentInformation = ({ investment }: CurrentInformationProps) => {
  return (
    <div className="bg-green-50 p-6 rounded-lg border border-green-200">
      <h4 className="text-lg font-semibold text-green-800 mb-4">Current Information</h4>
      <div className="space-y-3">
        <div className="flex justify-between">
          <span className="text-sm text-gray-600">Current Balance:</span>
          <span className="font-semibold">{formatCurrency(investment.currentBalance)}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-sm text-gray-600">Payments Remaining:</span>
          <span className="font-semibold">{investment.remainingTerms} months</span>
        </div>
        <div className="flex justify-between">
          <span className="text-sm text-gray-600">Property Value:</span>
          <span className="font-semibold">{formatCurrency(investment.propertyValue)}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-sm text-gray-600">Payment History:</span>
          <span className="font-semibold">{investment.paymentHistory || 'Contact for details'}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-sm text-gray-600">Credit:</span>
          <span className={`font-semibold ${
            investment.creditRating === 'Good' ? 'text-green-600' : 
            investment.creditRating === 'Bad' ? 'text-red-600' : 
            'text-gray-600'
          }`}>
            {investment.creditRating || 'N/A'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CurrentInformation;
